(() => {
  const init = root => root.querySelectorAll?.('[data-s7-age]').forEach(section => {
    if (section.dataset.ready) return; section.dataset.ready='1';
    const slider=section.querySelector('[data-age-slider]');
    const value=section.querySelector('[data-age-value]');
    const band=section.querySelector('[data-age-band]');
    const setting=section.querySelector('[data-age-setting]');
    const height=section.querySelector('[data-age-height]');
    const copy=section.querySelector('[data-age-copy]');
    const img=section.querySelector('[data-age-image]');
    const config=JSON.parse(section.querySelector('[data-age-config]').textContent);
    const buttons=[...section.querySelectorAll('[data-age-jump]')];
    const getStage=age=>age<=8?'young':age<=11?'middle':'older';
    const meta={
      young:{band:'6–8 YEARS',setting:'LOW · 87.5 CM',height:'87.5 cm'},
      middle:{band:'9–11 YEARS',setting:'MID · 93.5 CM',height:'93.5 cm'},
      older:{band:'12–14 YEARS',setting:'HIGH · 99.5 CM',height:'99.5 cm'}
    };
    function update(){
      const age=Number(slider.value), stage=getStage(age), m=meta[stage];
      value.textContent=age+' years old'; band.textContent=m.band; setting.textContent=m.setting; height.textContent=m.height; copy.textContent=config[stage].copy||'';
      if(img && config[stage].image) img.src=config[stage].image;
      buttons.forEach(b=>b.classList.toggle('is-active',getStage(Number(b.dataset.ageJump))===stage));
    }
    slider.addEventListener('input',update);
    buttons.forEach(b=>b.addEventListener('click',()=>{slider.value=b.dataset.ageJump;update();}));
    update();
  });
  if (window.__ISWS7AgeFit) {
    window.__ISWS7AgeFit.init(document);
    return;
  }

  window.__ISWS7AgeFit = { init };

  const boot = () => window.__ISWS7AgeFit.init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Motion lifecycle event: theme assets are fully ready.
  document.addEventListener('page:loaded', boot);

  // Shopify Theme Editor section reload.
  document.addEventListener('shopify:section:load', e => {
    window.__ISWS7AgeFit.init(e.target);
  });
})();